<template>
  <div class="wrapper-overlay open-overlay">
    <OverlayHeader />
    <div class="container-overlay overlay-form">
      <div class="overlay-message">
        <img src="/ext_files/prepaid/f2g/images/Success@2x.png" class="logo-overlay" />
        <div class="title-overlay1">
          {{selectedBundle.hasDataJump ? words['myf2g.bundles.success.modal.datajump.title'] : words['myf2g.bundles.success.modal.title'] }}
        </div>
        <div class="title-overlay2" v-html="selectedBundle.positiveFeedback"></div>
        <div class="overlay-button-container">
          <a :href="goToDashboard">
            <div class="button-overlay container-button blue-btn">
              {{ words['myf2g.bundles.success.modal.button'] }}
            </div>
          </a>
          <a v-if="selectedBundle.hasDataJump" :href="goToDataJump">
            <div class="button-overlay container-button purple-btn">
              {{ words['myf2g.bundles.success.modal.datajump'] }}
            </div>
          </a>
        </div>
        <div v-if="selectedBundle.hasDataJump" class="disclaimer-area">
          <div class="disclaimer-title" @click="showNotesVal = !showNotesVal"> {{ infoLabel }}</div>
          <div v-if="showNotesVal" class="disclaimer-subtitle" v-html="selectedBundle.dataJumpNotes"></div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import OverlayHeader from "@/components/OverlayHeader.vue"
import store from '@/store/index'

export default {
  name: "SuccessfulActivation",
  components: {
    OverlayHeader
  },
  data() {
    return {
      words: {},
      showNotes: false
    };
  },
  created() {

  },
  beforeMount() {
    if (sessionStorage.getItem("wcs_myf2bundlessuccessmodal_" + this.locale) != null) {
      this.words = JSON.parse(sessionStorage.getItem("wcs_myf2bundlessuccessmodal_" + this.locale));
    } else {

      let config = {
        method: 'get',
        url: '/gr/f2g/vueContentService/',
        params: {
          ciKey: 'myf2bundlessuccessmodal',
          locale: this.locale,
        }
      }

      let self = this;
      this.axios(config).then(function (response) {
        console.log(response);
        self.words = response.data;
        sessionStorage.setItem("wcs_myf2bundlessuccessmodal_" + self.locale, JSON.stringify(self.words));

      }).catch(function (error) {
        console.error(error);
      })

    }
  },
  computed: {
    infoLabel() {
      if (this.locale == 'en_US') {
        return 'Details'
      } else {
        return 'Λεπτομέρειες'
      }
    },
    showNotesVal: {
      get() {
        return this.showNotes;
      },
      set(value) {
        this.showNotes = value;
      }
    },
    locale() {
      return store.state.locale;
    },
    goToDashboard() {
      if (this.locale == 'en_US') {
        return '/en/myf2g/'
      } else {
        return '/gr/myf2g/'
      }
    },
    goToDataJump() {
      if (this.locale == 'en_US') {
        return '/en/f2g/upiresies/online-ananeosi-hronou-omilias/online-ananeosi-hronou-omilias-meso-myf2g-/?dataJumpFlow=true'
      } else {
        return '/gr/f2g/upiresies/online-ananeosi-hronou-omilias/online-ananeosi-hronou-omilias-meso-myf2g-/?dataJumpFlow=true'
      }
    },
    username() {
      return store.state.username;
    },
    msisdn() {
      return store.state.msisdn
    },
    selectedBundle() {
      return store.state.selectedBundle;
    }
  },
  methods: {

  }
};
</script>

<style scoped>
.overlay-message{
  overflow: auto ;
}
.disclaimer-area{
  margin-top: 20px;
  display: flex;  
  justify-content: center;
  flex-direction: column;
  align-self: center;
  padding: 10px;
}
.disclaimer-title{
  text-align: center;
  font-family: Manrope-Medium;
  font-size: 18px;
  cursor: pointer;
  padding-left: 10px;
}
.disclaimer-subtitle{
  text-align: left;
  padding-top: 10px;
  border-top: 1px solid black;
}
.container-overlay.overlay-modal{
  z-index: 999999999;
  overflow: auto;
}
.container-overlay.overlay-modal .modal-wrapper{
  height: unset;
}


</style>